/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabel
 */
export interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabel {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabel
     */
    value?: string;
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabelFromJSON(json: any): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabel {
    return JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabelFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabelToJSON(value?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

